<template>
  <div class="bg-indigo-600 h-screen">
    <div
      class="flex flex-col items-center justify-center pt-1/20 space-y-10 text-indigo-300"
    >
      <h3>{{ title }}</h3>
      <illustration name="notAllowed" />
      <div v-if="infos.reason === 'revoque'">
        <h5>
          {{ infos.host.firstname }} {{ infos.host.lastname }} a révoqué vos
          droits, vous n'avez plus accès à son Neopass.
        </h5>
      </div>
      <div>
        <h5>Pour vous connecter avec des identifiants, ou vous inscrire,</h5>
        <h5>vous pouvez vous diriger vers l'écran de connexion</h5>
      </div>
    </div>
    <div class="flex items-center justify-center mt-15">
      <router-link :to="{ name: 'Login' }">
        <action-button
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="Retour à l'écran de connexion"
          :uppercase="true"
          icon="log-out"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import ActionButton from './../../components/ActionButton';
import Illustration from './../../components/Illustration';

export default {
  name: 'InviteExpired',

  components: {
    Illustration,
    ActionButton,
  },

  props: {
    infos: Object,
  },

  data() {
    return {
      reason: this.$route.params.reason,
    };
  },

  computed: {
    title() {
      switch (this.infos.reason) {
        case 'wrong-email':
          return "Votre adresse email n'est pas liée à cet invité";
        case 'invitation-expiree':
          return 'Votre invitation a expirée';
        case 'mauvais-jeton':
          return "Le jeton utilisé n'existe pas";
        case 'revoque':
          return 'Invitation révoquée';
        default:
          return 'Votre invitation a expirée';
      }
    },
  },
};
</script>
